import { render } from "./ButtonLink.vue?vue&type=template&id=ed4c42d0&scoped=true"
import script from "./ButtonLink.vue?vue&type=script&lang=js"
export * from "./ButtonLink.vue?vue&type=script&lang=js"

import "./ButtonLink.vue?vue&type=style&index=0&id=ed4c42d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ed4c42d0"

export default script